/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CopyBaseCardColorDialog from "../dialogTypes/CopyBaseCardColorDialog";
import CopyBaseCardColorButtonLayout from "../layout/CopyBaseCardColorButtonLayout";

function CopyBaseCardColorButton(props) {
	const { t } = useTranslation();
	const {
		schema,
		refresh,
		onSuccess,
		selectedCardClass,
		selectedEndUser,
		...others
	} = props;
	const [open, setOpen] = useState(false);

	const onOpen = () => {
		setOpen(true);
	};

	const onClose = () => {
		setOpen(false);
	};

	const onCreateSuccess = (msg) => {
		if (onSuccess) {
			refresh.refresh();
			onSuccess(msg);
		}
	};

	return (
		<>
			<CopyBaseCardColorButtonLayout
				id={"copy-base-card-color-button"}
				onClick={onOpen}
				{...others}
			/>
			<CopyBaseCardColorDialog
				id={"copy-base-card-color-dialog"}
				title={t("dialog.title.CopyBaseCardColor")}
				open={open}
				onClose={onClose}
				onSuccess={onCreateSuccess}
				schema={schema}
				selectedCardClass={selectedCardClass}
				selectedEndUser={selectedEndUser}
			/>
		</>
	);
}

export default CopyBaseCardColorButton;
